import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { setDataOnLocalStorage } from "../util/localStorage";
import useApi from "../hooks/useApi";
import { baseUrl } from "../config/apiConfig";
import AI_PDF_CONST from "../util/PdfAiConst";
import ErrorPopUpComponent from "./ErrorPopUpComponent";

const CredentialsLoginComponent = () => {
  const { callApi, loading } = useApi();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isMessageShow, setIsMessageShow] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsMessageShow(false);
    setErrorMessage("");

    try {
      const data = await callApi(
        `${baseUrl + AI_PDF_CONST.API_ENDPOINT.LOGIN}`,
        "POST",
        { source: "credentials", email, password }
      );

      setDataOnLocalStorage("token", data.data.access_token);

      const userObj = {
        auth_id: data.data.auth_id,
        auth_source: data.data.auth_source,
        email: data.data.email,
        id: data.data.id,
        name: data.data.name,
        userProfileImg: "",
        org_id: data.data.org_id,
      };
      setDataOnLocalStorage("userInfo", userObj);

      navigate("/home");
    } catch (err) {
      console.error("Login failed:", err.message);
      setIsMessageShow(true);
      setErrorMessage(err.message || "Invalid credentials. Please try again.");
    }
  };

  return (
    <div className="w-full">
      <form onSubmit={handleLogin} className="space-y-4">
        <div>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all"
            placeholder="Email address"
          />
        </div>
        <div>
          <input
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all"
            placeholder="Password"
          />
        </div>
        
        {loading ? (
          <div className="flex justify-center py-3">
            <div className="dot-pulse" style={{ backgroundColor: '#4f46e5' }}></div>
          </div>
        ) : (
          <button 
            type="submit" 
            className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-3 px-4 rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-[#1e2532] focus:ring-indigo-500 shadow-lg"
          >
            Sign In
          </button>
        )}
      </form>

      <ErrorPopUpComponent
        isErrorShow={isMessageShow}
        errorMessage={errorMessage}
        redirect=""
      />
    </div>
  );
};

export default CredentialsLoginComponent;
